import React from "react";
import "./liveTraining.css";
import "../../../page-layout.css";
import BigImgLive from "../../images/live.jpg";
import { Helmet } from "react-helmet";

const features = [
  "Merenje i testiranje na početku",
  "Praćenje napretka i vođenje ka cilju",
  "Plan prilagođen tvom telu i mogućnostima",
  "Pravilno izvođenje svake vežbe",
  "Motivacija i maksimalan rezultat",
  "Istezanje i oporavak nakon treninga",
];

export default function LiveTraining() {
  return (
    <div className="page-wrap">
      <Helmet>
        <title>Uživo trening | Mihailo Živanović</title>
        <meta
          name="description"
          content="Najperspektivniji vid saradnje. 1 na 1 trening sa trenerom u teretani — pravilna tehnika, motivacija i vidljivi rezultati."
        />
      </Helmet>

      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="page-hero-eyebrow">Usluge</div>
          <h1 className="page-hero-title">UŽIVO TRENING</h1>
          <p className="page-hero-desc">
            Najperspektivniji vid saradnje. Trener objašnjava, demonstrira i
            ispravlja tehniku na licu mesta — sistem 1 na 1 koji daje stvarne rezultate.
          </p>
        </div>
      </div>

      <div className="service-body">
        <div className="service-inner">
          <div className="service-text-col">
            <div className="service-section">
              <div className="section-eyebrow">O usluzi</div>
              <p className="service-p">
                Uživo treninzi su najmerodavniji i najkompletniji vid saradnje.
                Kroz sistem 1 na 1, trener koriguje tehniku na licu mesta,
                automatizuje pravilno disanje i izvlači tvoj puni potencijal.
              </p>
              <p className="service-p">
                Trener razmišlja za tebe, vodi te kroz trening, usmerava,
                asistira i motiviše. Jedino što ti moraš — da stegneš zube i
                zasučeš rukave. Uz pravo znanje to neće biti teško.
              </p>
              <p className="service-p">
                Treninzi se održavaju u{" "}
                <a
                  className="service-link"
                  href="https://maps.app.goo.gl/3GKRGbX24zaTXY8g9"
                  target="_blank"
                  rel="noreferrer"
                >
                  Planet Gym &amp; Fitness
                </a>
                , Beograd.
              </p>
            </div>

            <div className="service-section">
              <div className="section-eyebrow">Šta uključuje</div>
              <ul className="service-feature-list">
                {features.map((f) => (
                  <li key={f}>
                    <span className="feature-dot" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>

            <div className="service-price-box">
              <span className="service-price-label">Cena</span>
              <span className="service-price-value">Na upit</span>
              <p className="service-price-note">
                Pošaljite poruku ili pozovite za detalje o ceni.
              </p>
            </div>
          </div>

          <div className="service-img-col">
            <div className="service-img-wrap">
              <img src={BigImgLive} alt="Uživo trening" />
            </div>

            <div className="service-cta-box">
              <h3>Zainteresovan?</h3>
              <p>Zakaži prvi trening ili pošalji upit za više informacija.</p>
              <a href="/kontakt/" className="service-cta-btn">Zakaži trening</a>
              <a href="tel:+381600737363" className="service-tel-link">
                +381 60 073 7363
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="page-cta-strip">
        <div className="page-cta-strip-inner">
          <h2>SPREMAN ZA PRVI TRENING?</h2>
          <div className="page-cta-strip-actions">
            <a href="/kontakt/" className="btn-dark">Zakaži trening</a>
            <a href="tel:+381600737363" className="btn-outline">Pozovi me</a>
          </div>
        </div>
      </div>
    </div>
  );
}
